'use strict';

const { isMobile } = require('../../../../../../app_lyonscg/cartridge/client/default/js/util/utils');
/**
 * set collapsible behavior for footer menu items
 */
function setCollapseBehavior() {
    if ($('.footer-item').length > 0) {
        $('.footer-item').each(function (i) {
            $(this).addClass('mobile-item');
            $(this).find('ul').attr('id', 'footertab-' + i).addClass('collapse');
            $(this).find('b').attr({
                'data-toggle': 'collapse',
                'data-target': '#footertab-' + i
            }).addClass('collapsed');
            $('.footer-links').addClass('mobile-view');
        });
    }
}

/**
 * remove collapsible behavior for footer menu items
 */
function removeCollapseBehavior() {
    if ($('.footer-item').length > 0) {
        $('.footer-item').each(function () {
            $(this).removeClass('mobile-item');
            $(this).find('ul').removeAttr('id').removeClass('collapse');
            $(this).find('b').removeAttr('data-toggle data-target').removeClass('collapsed');
        });
        $('.footer-links').removeClass('mobile-view');
    }
}

if (isMobile() === true) {
    setCollapseBehavior();
}

$(window).on('resize', function () {
    var collapibleItem = $('.footer-links.mobile-view');
    if (window.innerWidth < 768) {
        if (collapibleItem.length === 0) {
            setCollapseBehavior();
        }
    }
    if (window.innerWidth > 767) {
        if (collapibleItem.length === 1) {
            removeCollapseBehavior();
        }
    }
});
